import IOrderOutput from "@/api/models/IOrderOutput";

export default function createOrderOutput(): IOrderOutput {
  return {
    id: "",
    clientId: "",
    clientStaffId: "",
    state: 1,
    endUser: ""
  };
}
